export const STRINGS = {
    SKIN_ANALYSIS_URL: "/skin-analysis-ai",
    API_ERROR_MESSAGE: "An error occurred. Please try again later."
}
